import React from 'react';

function Footer(props) {
  return (
    <footer>
      <nav>
        <ul>
          <li><a>FAQs</a></li>
          <li><a>Feedback</a></li>
          <li><a>Download Desktop Client</a></li>
          <li><a>English</a></li>
        </ul>
      </nav>
      <nav>
        <ul>
          <li><a>Terms of Use</a></li>
          <li><a>Privacy and cookie policy</a></li>
          <li>© 2017 Skype and/or Microsoft.</li>
        </ul>
      </nav>
    </footer>
  );
}

export default Footer;


// WEBPACK FOOTER //
// ./frontend/components/Footer.jsx